// Track location changes
import { LOCATION_CHANGE } from "react-router-redux"

let prevPathname = ""

const locationChangeMiddleware = () => next => action => {
  if (action.type === LOCATION_CHANGE) {
    const newAction = {
      ...action,
      payload: {
        ...action.payload,
        drillUp: destructureLhoRef(action.payload.pathname).length <= destructureLhoRef(prevPathname).length,
      },
    }
    prevPathname = action.payload.pathname
    return next(newAction)
  }
  return next(action)
}
export default locationChangeMiddleware

const destructureLhoRef = path => {
  let match = path.match(/\/(?:lho|case)\/([0-9]+)[./]?([0-9]+)?[./]?([0-9]+)?/i)
  return match ? match.slice(1).filter(Boolean) : []
}



// WEBPACK FOOTER //
// ./src/common/locationChangeMiddleware.js